import { cn } from "@/lib/utils/cn";
import { type ComponentPropsWithoutRef } from "react";

export type PriorityLevel = "none" | "low" | "medium" | "high" | "urgent";

const LEVEL_TO_COUNT: Record<PriorityLevel, number> = {
  none: 0,
  low: 1,
  medium: 2,
  high: 3,
  urgent: 3,
};

const BARS = [
  { x: 1, height: 4 },
  { x: 5, height: 7 },
  { x: 9, height: 10 },
] as const;

export type PriorityIconProps = {
  level?: PriorityLevel;
} & ComponentPropsWithoutRef<"svg">;

export const PriorityIcon = ({
  level = "low",
  className,
  ...props
}: PriorityIconProps) => {
  const activeBars = LEVEL_TO_COUNT[level];
  const isUrgent = level === "urgent";

  return (
    <svg
      viewBox="0 0 16 12"
      role="img"
      aria-hidden="true"
      className={cn("h-4 w-4 fill-current", className)}
      {...props}
    >
      {BARS.map((bar, index) => {
        const isActive = index < activeBars;
        const barHeight = level === "none" ? 2 : bar.height;
        const y = 12 - barHeight;

        return (
          <rect
            key={bar.x}
            x={bar.x}
            y={y}
            width={2}
            height={barHeight}
            rx={1}
            className={cn(
              "transition-opacity",
              level === "none"
                ? "opacity-60"
                : isActive
                  ? "opacity-100"
                  : "opacity-25",
            )}
          />
        );
      })}
      {isUrgent && (
        <>
          <rect
            x={13}
            y={2}
            width={2}
            height={7}
            rx={1}
            className="fill-red-500"
          />
          <rect
            x={13}
            y={10}
            width={2}
            height={2}
            rx={1}
            className="fill-red-500"
          />
        </>
      )}
    </svg>
  );
};
